import PropTypes from 'prop-types';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withDigitalData } from '../../../utils/DigitalDataContext';
import { withLabels } from '../../../utils/LabelsContext';
import { withProduct } from '../../../utils/ProductContext';
import { ScrollToStyles } from '../../ui/ScrollTo/ScrollTo.style';
import { useProductTopSpecifications } from '../hooks/useProductTopSpecifications';
import { ProductTopSpecificationsStyle } from './style';

const ACCORDION_OPEN_EVENT = 'openSpecificationsAccordion';

const ProductTopSpecifications = ({ product, labels, scollToElementId, digitalData, appCtx }) => {
  const hookData = useProductTopSpecifications({ product, labels, scollToElementId, digitalData, appCtx });

  const {
    topSpecifications,
    topSpecificationsTitle,
    viewMoreText,
    specificationsTitle,
    isDesktop,
    isSodimacSA,
    shouldShowDivider,
    shouldRender,
  } = hookData;

  const handleViewMoreClickWithScroll = () => {
    // Scroll to the accordion
    const accordionEl = document.getElementById('productSpecificationsAccordion');
    if (accordionEl) {
      accordionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Dispatch custom event to open specifications item after a short delay to ensure scroll has started
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent(ACCORDION_OPEN_EVENT));
      }, 100);
    }
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <>
      <div className="product-top-specifications" data-testid="product-top-specifications">
        <div className="product-top-specifications__container">
          <h3 className="product-top-specifications__title" data-testid="product-top-specifications__title">
            {topSpecificationsTitle}
          </h3>

          <div className="product-top-specifications__list" data-testid="product-top-specifications__list">
            <ul className="product-top-specifications__items">
              {topSpecifications.map((spec) => (
                <li key={spec.name} className="product-top-specifications__item">
                  <span className="product-top-specifications__item-name">{spec.name}:</span>
                  <span className="product-top-specifications__item-value">{spec.value}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="product-top-specifications__actions">
            {isDesktop ? (
              <div className="product-top-specifications__scroll-action">
                <button
                  className={`specifications-action rebranded ${isSodimacSA ? 'so-com' : ''}`}
                  id="testId-topSpecifications-action-btn"
                  onClick={handleViewMoreClickWithScroll}
                  type="button"
                >
                  {isSodimacSA
                    ? labels?.SO_COM_VIEW_MORE_SPECIFICATONS || 'Ver más'
                    : labels?.VIEW_MORE_SPECIFICATONS || 'Ver más'}
                </button>
              </div>
            ) : (
              <div className="product-top-specifications__mobile-actions">
                <button
                  type="button"
                  onClick={handleViewMoreClickWithScroll}
                  className="product-top-specifications__view-more-button"
                  data-testid="product-top-specifications__view-more-button"
                  aria-label={`${viewMoreText} - ${specificationsTitle}`}
                >
                  {viewMoreText}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {shouldShowDivider && (
        <div className="product-top-specifications__divider" data-testid="product-top-specifications__divider" />
      )}

      <style jsx>{ProductTopSpecificationsStyle}</style>
      <style jsx>{ScrollToStyles}</style>
    </>
  );
};

ProductTopSpecifications.defaultProps = {
  scollToElementId: null,
};

ProductTopSpecifications.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  scollToElementId: PropTypes.string,
  digitalData: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export { ProductTopSpecifications };
export default withLabels(withProduct(withDigitalData(withApplicationContext(ProductTopSpecifications))));
